"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GEFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_84)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_84`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.07983 0H28.5202V24H-5.07983V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.32014 9.6H-6.35986V14.4H9.32014V24H14.1201V14.4H29.8001V9.6H14.1201V0H9.32014V9.6Z",
					fill: "#EB000E"
				}),
				/* @__PURE__ */ n("path", {
					d: "M21.3201 4.32002L21.0001 2.40002H22.6001L22.2801 4.32002L24.2001 4.00002V5.60002L22.2801 5.28002L22.6001 7.20002H21.0001L21.3201 5.28002L19.4001 5.60002V4.00002L21.3201 4.32002ZM1.00008 4.32002L0.680078 2.40002H2.28008L1.96008 4.32002L3.88008 4.00002V5.60002L1.96008 5.28002L2.28008 7.20002H0.680078L1.00008 5.28002L-0.919922 5.60002V4.00002L1.00008 4.32002ZM1.00008 18.72L0.680078 16.8H2.28008L1.96008 18.72L3.88008 18.4V20L1.96008 19.68L2.28008 21.6H0.680078L1.00008 19.68L-0.919922 20V18.4L1.00008 18.72ZM21.3201 18.72L21.0001 16.8H22.6001L22.2801 18.72L24.2001 18.4V20L22.2801 19.68L22.6001 21.6H21.0001L21.3201 19.68L19.4001 20V18.4L21.3201 18.72Z",
					fill: "#EB000E"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_84`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GEFlag };
